import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './router/router'
import store from './store/'
import {routerMode} from './config/env'
import './config/rem'
import FastClick from 'fastclick'
import ElementUI from 'element-ui';
import './filter'
import {getCookie,delCookie} from './utils'



if ('addEventListener' in document) {
    document.addEventListener('DOMContentLoaded', function() {
        FastClick.attach(document.body);
    }, false);
}
// import '../build/mock.js';

// 导入所有的过滤器变量
// import * as custom from './components/filter'

// 导出的是对象，可以直接通过key和value来获得过滤器的名和过滤器的方法
// Object.keys(custom).forEach(key => {
//     Vue.filter(key, custom[key])
// })

Vue.use(VueRouter)
Vue.use(ElementUI)



  
	

const router = new VueRouter({
	routes,
	mode: routerMode,
	strict: process.env.NODE_ENV !== 'production',
	scrollBehavior (to, from, savedPosition) {
	    if (savedPosition) {
		    return savedPosition
		} else {
			if (from.meta.keepAlive) {
				from.meta.savedPosition = document.body.scrollTop;
			}
		    return { x: 0, y: to.meta.savedPosition || 0 }
		}
	}
})
router.beforeEach((to, from, next) => {



	if (to.matched.some(record => record.meta.requireAuth)) { // 判断该路由是否需要登录权限,能检测出带参数的路由

				if (getCookie('isLogin')) {  // 通过本地存储获取当前的登录flag是否存在
					next()
				} else {
					localStorage.removeItem('mgt_user');
					delCookie('isLogin')
					next({
						path: '/login'
					})
				}
			} else {
				if(to.path=='/login'){
					if (getCookie('isLogin')) {
						next({path:'/home'})
						return
					}

				}
				 next()
			}




  })
new Vue({
	router,
	store,
}).$mount('#app')




// WEBPACK FOOTER //
// ./src/main.js